import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['modal']
  connect () {
  }

  new (event) {
    const button = event.currentTarget

    // Collect data from within this specific card
    const addressData = {
      city: '',
      companyName: '',
      country: '',
      default: false,
      firstName: '',
      id: '',
      lastName: '',
      phone: '',
      street: '',
      type: button.dataset.addressType,
      zipCode: ''
    }

    this.populateModal(addressData)
  }

  edit (event) {
    const button = event.currentTarget
    const addressId = button.dataset.addressId

    // Find the closest address_card element
    const card = button.closest('.address_card')

    // Collect data from within this specific card
    const addressData = {
      city: card.querySelector('.city')?.textContent?.trim() || '',
      companyName: card.querySelector('.companyName')?.textContent?.trim() || '',
      country: card.querySelector('.country')?.textContent?.trim() || '',
      default: card.querySelector('.default')?.textContent?.trim() === 'true',
      firstName: card.querySelector('.firstName')?.textContent?.trim() || '',
      id: addressId,
      lastName: card.querySelector('.lastName')?.textContent?.trim() || '',
      phone: card.querySelector('.phone')?.textContent?.trim() || '',
      street: card.querySelector('.street')?.textContent?.trim() || '',
      type: card.querySelector('.type')?.textContent?.trim() || '',
      zipCode: card.querySelector('.zipCode')?.textContent?.trim() || ''
    }

    this.populateModal(addressData)
  }

  populateModal (addressData) {
    // select the type of address
    const addressModal = this.modalTarget

    const billingAddressTypeRadioInput = addressModal.querySelector('#address_type_billingaddress')
    const cityInput = addressModal.querySelector('input[name="address[city]"]')
    const companyNameInput = addressModal.querySelector('input[name*="company_name"]')
    const countrySelect = addressModal.querySelector('select[name*="country"]')
    const defaultCheckboxInput = addressModal.querySelector('#address_default')
    const firstNameInput = addressModal.querySelector('input[name*="first_name"]')
    const idInput = addressModal.querySelector('input[name*="id"]')
    const lastNameInput = addressModal.querySelector('input[name*="last_name"]')
    const phoneInput = addressModal.querySelector('input[name*="phone"]')
    const shippingAddressTypeRadioInput = addressModal.querySelector('#address_type_shippingaddress')
    const streetInput = addressModal.querySelector('input[name*="street"]')
    const zipCodeInput = addressModal.querySelector('input[name*="zip_code"]')

    if (cityInput) cityInput.value = addressData.city
    if (companyNameInput) companyNameInput.value = addressData.companyName
    if (countrySelect) countrySelect.value = addressData.country
    if (defaultCheckboxInput) defaultCheckboxInput.checked = addressData.default
    if (firstNameInput) firstNameInput.value = addressData.firstName
    if (idInput) idInput.value = addressData.id
    if (lastNameInput) lastNameInput.value = addressData.lastName
    if (phoneInput) phoneInput.value = addressData.phone
    if (streetInput) streetInput.value = addressData.street
    if (zipCodeInput) zipCodeInput.value = addressData.zipCode

    // Set the address type radio button
    if (shippingAddressTypeRadioInput && billingAddressTypeRadioInput) {
      if (addressData.type === 'BillingAddress') {
        billingAddressTypeRadioInput.checked = true
      } else {
        shippingAddressTypeRadioInput.checked = true
      }
    }
  }
}
